export default __webpack_public_path__ + "static/media/Snd_ClowerN.07d121d6.mp3";